"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteView = exports.DEFAULT_ERROR_RESULT = void 0;
const React = __importStar(require("react"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const merlin_input_1 = require("@travelnest/merlin.input");
const merlin_loader_1 = require("@travelnest/merlin.loader");
const merlin_option_list_1 = require("@travelnest/merlin.option-list");
const Autocomplete_styled_1 = require("./Autocomplete.styled");
exports.DEFAULT_ERROR_RESULT = { label: 'An error occurred, please try again.' };
const getElementOffset = (element) => {
    let n = element;
    let o = 0;
    while (n && n.parentNode) {
        o += n.offsetTop || 0;
        n = n.parentNode;
    }
    return o;
};
const getResultsListHeight = (singleResultHeight, resultsToDisplay, totalResultCount) => {
    /*
    This calculation assumes single result height is the height of one result which has a border. It also assumes
    that adjacent results will overlap their shared border. If there are more results than we want to show,
    add a little extra to indicate there are more results below.
    */
    const borderWidth = 1;
    const n = Math.min(totalResultCount, resultsToDisplay);
    const extra = totalResultCount > resultsToDisplay ? singleResultHeight / 2 : 0;
    return (singleResultHeight - borderWidth) * n + borderWidth + extra;
};
const useRerender = () => {
    const [dummy, setDummy] = React.useState(false);
    return () => setDummy(!dummy);
};
function AutocompleteView(props) {
    const { results, loading, error, errorMessage, inputPlaceholder, onChange, onFocus, onSelect, resultsToDisplay } = props;
    const inputRef = React.useRef(null);
    const optionsRef = React.useRef(null);
    const rerender = useRerender();
    const [inputValue, setInputValue] = React.useState('');
    const [offset, setOffset] = React.useState(null);
    const [optionElementHeight, rectHeightRefCallback] = (0, merlin_hooks_1.useClientRectHeight)();
    const initialOffset = offset === null && !!optionsRef.current ? getElementOffset(optionsRef.current) : 0;
    if (initialOffset !== offset) {
        setOffset(initialOffset);
    }
    // select first option if Down Arrow pressed from input (if options available)
    const onArrowDownKeyPress = (e) => {
        if (e.key === 'ArrowDown') {
            if (optionsRef.current) {
                const firstOption = optionsRef.current.getElementsByTagName('li')[0];
                if (firstOption) {
                    e.preventDefault();
                    firstOption.focus();
                }
            }
        }
    };
    return React.createElement(Autocomplete_styled_1.StyledAutocompleteWrapper, null,
        React.createElement(merlin_input_1.Input, Object.assign({ ref: inputRef, value: inputValue, id: "autocomplete" }, onFocus ? { onFocus } : {}, { onChange: (e) => {
                setInputValue(e.target.value);
                if (onChange)
                    onChange(e.target.value);
            }, onKeyDown: onArrowDownKeyPress, placeholder: inputPlaceholder || '' })),
        !error && !!(results && results.length) && React.createElement(Autocomplete_styled_1.StyledResultsList, Object.assign({}, resultsToDisplay ? { height: getResultsListHeight(optionElementHeight, resultsToDisplay, results.length) } : undefined, { offset: (offset || 0) + 10, ref: optionsRef }),
            React.createElement(merlin_option_list_1.OptionList, { onSelect: (item) => {
                    setInputValue(item.label);
                    if (onSelect)
                        onSelect(item);
                }, options: results, priorRef: inputRef })),
        error && React.createElement(Autocomplete_styled_1.StyledErrorResultsList, { offset: (offset || 0) + 10, ref: optionsRef },
            React.createElement(merlin_option_list_1.OptionList, { options: errorMessage ? [{ label: errorMessage }] : [exports.DEFAULT_ERROR_RESULT], priorRef: inputRef })),
        !error && loading && React.createElement(Autocomplete_styled_1.StyledLoader, { hasResults: !!(results && results.length), height: optionElementHeight - 1 },
            React.createElement(merlin_loader_1.Loader, null)),
        optionElementHeight === null &&
            // create an empty "template" OptionList so we can measure it
            // then set the height of the final rendered list
            React.createElement("div", { className: "autocomplete__height-calc", style: { visibility: 'hidden', position: 'absolute', zIndex: -1 }, ref: (el) => {
                    rectHeightRefCallback(el);
                    // Force a rerender after the callback. This hack is not ideal, but makes testing
                    // this behaviour far easier. We should look to replace this with better tests.
                    rerender();
                } },
                React.createElement(merlin_option_list_1.OptionList, { options: [{ label: 'label' }] })));
}
exports.AutocompleteView = AutocompleteView;
//# sourceMappingURL=AutocompleteView.js.map